<template>
  <div class="modal-screen-table-sizes">
    <div class="modal-table-sizes">
        <div class="modal-top">
            <div class="modal-top__title">таблица размеров</div>
            <div class="modal-top__close">
                <svg width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="1.35355" y1="0.646447" x2="32.3536" y2="31.6464" stroke="black" />
                    <line x1="0.652238" y1="31.6407" x2="32.6765" y2="0.640722" stroke="black" />
                </svg>
            </div>
        </div>
        <!-- <div class="modal-table__title">Женские размеры</div> -->
        <div class="modal-table__wrap">
            <div class="modal-table">
                <div class="modal-table__row" v-for="(row, rowIndex) in tableData" :key="rowIndex" :class="'test-' + rowIndex">
                    <div class="modal-table__col modal-table__col--1">
                      {{ rowNames[rowIndex] }}
                    </div>
                    <div
                      v-for="(size, sizeIndex) in row"
                      class="modal-table__col"
                      :class="'modal-table__col--' + (sizeIndex + 2)"
                      :key="sizeIndex"
                    >
                      {{ size }}
                    </div>
                </div>
                <!-- <div class="modal-table__row">
                    <div class="modal-table__col modal-table__col--1">
                      Обхват груди, см
                    </div>
                    <div class="modal-table__col modal-table__col--2">40/42</div>
                    <div class="modal-table__col modal-table__col--3">42/44</div>
                    <div class="modal-table__col modal-table__col--4">44/46</div>
                    <div class="modal-table__col modal-table__col--5">46/48</div>
                    <div class="modal-table__col modal-table__col--6">48/50</div>
                    <div class="modal-table__col modal-table__col--7">50/52</div>
                </div>
                <div class="modal-table__row">
                    <div class="modal-table__col modal-table__col--1">
                      Длина рукава, см
                    </div>
                    <div class="modal-table__col modal-table__col--2">82 см</div>
                    <div class="modal-table__col modal-table__col--3">88 см</div>
                    <div class="modal-table__col modal-table__col--4">94 см</div>
                    <div class="modal-table__col modal-table__col--5">100 см</div>
                    <div class="modal-table__col modal-table__col--6">106 см</div>
                    <div class="modal-table__col modal-table__col--7">112 см</div>
                </div>
                <div class="modal-table__row">
                    <div class="modal-table__col modal-table__col--1">
                      Длина изделия, см
                    </div>
                    <div class="modal-table__col modal-table__col--2">64 см</div>
                    <div class="modal-table__col modal-table__col--3">70 см</div>
                    <div class="modal-table__col modal-table__col--4">76 см</div>
                    <div class="modal-table__col modal-table__col--5">82,5 см</div>
                    <div class="modal-table__col modal-table__col--6">89 см</div>
                    <div class="modal-table__col modal-table__col--7">95,5 см</div>
                </div> -->
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import { defineComponent } from "vue";

export default {
  name: "modalSizesComponent",
  props: [
    'article'
  ],
  data()
  {
    return {
      tableData: [],
      rowNames: [
        'Размер',
        'Обхват груди, см',
        'Длина рукава, см',
        'Длина изделия, см'
      ]
    }
  },
  methods: {
    getTableSizes() {
      axios.get(`/local/api/handlers/tableSizesHandler.php?article=${this.article}`)
        .then(response => {
            this.tableData = response.data.data;
        })
        .catch((error) => {
            this.toast.error("При получении данных корзины произошла ошибка");
        })
    }
  },
  mounted() {
    this.getTableSizes();
  }
}
</script>
